import { icon, Icon } from '../lib/fa-icons.js';
/*
Place this widget just before the closing tag of the .Article__Main element

this is for single post pages (including live blog) and the fp
*/

import Widget from "./base.js";
import { getCookie, setCookie } from "tpm-utils";

export class StickyAdNov26Widget extends Widget {
  componentWillMount() {    
    this.toggleDismiss = this.toggleDismiss.bind(this);

    if (getCookie("tpm_sticky_ad_nov_26_dismissed")) {
      this.state.dismissed = true;
    }
  }

  componentDidMount() {
  }

  toggleDismiss(e) {
    e.preventDefault();
    e.stopPropagation();
    setCookie("tpm_sticky_ad_nov_26_dismissed", "1", 0.125); //0.125 days = 3 hours
    this.setState({ dismissed: true });
  }

  get href() {
    return `https://${window.location.host}/memberships`;
  }

  renderContent() {

    if (this.state.dismissed) return null;
    
    return (
      <div className={`StickyAdNov26 ${this.props.standalone ? '--standalone' : ''} ${this.props.fp ? '--fp' : ''}`}>
        <div
          className={`StickyAdNov26__Inner ${this.props.standalone ? '--standalone' : ''}`}
        >
          <div className="StickyAdNov26__Text"><span>election sale!</span> 40% Off All TPM&nbsp;memberships</div>
          {!this.props.standalone && (  
            <div className="StickyAdNov26__CTA">
              <a className="Button --sticky-ad-nov-26" href={this.href}>JOIN NOW</a>
            </div>
          )}
          {!this.props.standalone && (  
            <div className="StickyAdNov26__Dismiss" onClick={this.toggleDismiss}>
              <Icon name='xmark' style="light" /> 
            </div>
          )}
        </div>
      </div>
    );
  }
}
